import styled from 'styled-components';

// Styled component for the checkbox container
export const CheckboxContainer = styled.div`
  /* display: inline-block;
  vertical-align: middle; */
  display: flex;
`;

// Hidden checkbox input
export const HiddenCheckbox = styled.div`
  width: 16px;
  height: 16px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
`;

// Styled component for the visible checkbox
export const StyledCheckbox = styled.div`
  width: 16px;
  height: 16px;
  /* border: 1px solid #228be6; */
  border-radius: 4px;
  /* background-color: #228be6; */
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ disabled }) => (disabled ? '#F1F3F5' : '#228be6')};
  border: ${({ disabled }) => (disabled ? '1px solid #ADB5BD' : '1px solid #228be6')};
`;
